<button *ngIf="selectionsEnabled" class="btn btn-outline-primary btn-sm w-100 mt-2" (click)="toggleSelection($event)">
  <span translate>SELECT</span>
  <i class="fa ml-2" [ngClass]="{ 'fa-square': !isSelected, 'fa-check-square': isSelected }"></i>
</button>
